import { ApiError, apiFetch } from './http';
import { buildPortalApiPath } from './routes';

export class ParticipationSubmissionError extends ApiError {
  code?: string;
  fieldErrors?: Record<string, string>;

  constructor(message: string, status: number, code?: string, fieldErrors?: Record<string, string>) {
    super(message, status);
    this.name = 'ParticipationSubmissionError';
    this.code = code;
    this.fieldErrors = fieldErrors;
  }
}

export async function submitParticipationRequest(values: Record<string, unknown>): Promise<void> {
  const response = await apiFetch(buildPortalApiPath('/participation-requests'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ values }),
  });

  if (response.ok) {
    return;
  }

  const body = await response.json().catch(() => ({})) as {
    code?: string;
    error?: string;
    fieldErrors?: Record<string, string>;
  };
  throw new ParticipationSubmissionError(
    body.error ?? `Participation request failed: ${response.status}`,
    response.status,
    body.code,
    body.fieldErrors,
  );
}
